import React, { useEffect, useState } from 'react'
import CardArticle from "../../atoms/card-article/cardArticle";
import { getFilteredResults } from "../../../services/filter";


import './articleSection.scss'

function filterTranslate(word: string) {
  switch (word) {
    case "Artículos":
      return ["artículo", "articles"];
    default:
      return word;
  }
}

const articleSection = (props) => {
  const name =`${props.nombreCategoria.toLowerCase().replace(/ /g, '-')}`
  const [dataArr, setDataArr] = useState<any[] | null>(null);
  const [initial, setInitial] = useState(10);

  const seeAll = () => {
    setInitial(initial + 10);
  };

  const makeSearch = async (
    contentType: string,
  ) => {
    const resultArr: any[] = [];
    
      let contentTypes = contentType.split(",");
      for (const type of contentTypes) {
        const request = await getFilteredResults(
          "",
          filterTranslate(type)[0],
          "100",
          "",
          "",
          "AZ",
        );

        if (props.nombreCategoria === 'Historia' ) {
            request?.data.data.filter.map((el) => {
              if (el.slug.split('/')[1] === 'historias') {
                resultArr.push({
                   el
                });
              }
            })
        }  else if (props.nombreCategoria === 'Comunidades') {
            request?.data.data.filter.map((el) => {
              if (el.slug.split('/')[1] === 'comunidades') {
                resultArr.push({
                  el
                });
              }
            })
        } else if (props.nombreCategoria === 'Nuestros Servicios') {
          request?.data.data.filter.map((el) => {
            if (el.slug.split('/')[1] === 'nuestros-servicios') {
              resultArr.push({
                el
              });
            }
          })
        } else if (props.nombreCategoria === 'Sala de lectura') {
          request?.data.data.filter.map((el) => {
            if (el.slug.split('/')[1] === 'sala-de-lectura') {
              resultArr.push({
                el
              });
            }
          })
        } else {
          request?.data.data.filter.map((el) => {
            if (el.slug.split('/')[2] === name) {
              resultArr.push({
                 el
              });
            }
          })
        }
        
    }
    setDataArr(resultArr);
  };

  useEffect(() => {
    makeSearch('Artículos')
  }, [])

  return (
    <div>
      <div className="m-resultbook">
          <div className="m-resultbook-content">
            <div className="m-resultbook-content-header">
              <h2>
                {`Todas las historias - ${dataArr?.length}`}
              </h2>
            </div>
            <div
              className={
                "m-resultbook-content-result " + "m-resultbook-content-article" +
                (dataArr?.length < 9 ? "" : " m-resultbook-content-five")
              }
            >
              {/* {props.children} */}
              {dataArr?.slice(0,initial).map((item, index) => {
               return <CardArticle article={item.el} key={`result${index}`}/>;
              })}
              
            </div>
          </div>
          <div className="m-resultbook-button">
              {dataArr?.length > 9 && initial < dataArr?.length? (
                <p 
                  onClick={() => seeAll()}
                >
                  CARGAR MÁS
                </p>
              ) : null}
            </div>
        </div>
    </div>
  )
}

export default articleSection
